import * as React from "react";
import { styled } from "styled-components";
import { useIntl } from "react-intl";
import { PanelContainer, PanelPadding } from "@wayflyer/flyui-dataviz";

import { Spacer } from "../../../../components/shared";
import { ProfitabilityChartsContainer } from "../../../../components/styled";
import { OptimalCacCalculator } from "../optimal-cac-calculator";
import type { OptimalCacFormProps } from "../optimal-cac-calculator/optimal-cac-calculator";
import type { SummaryPanelProps } from "../../../../components/summary-panel";
import { SummaryPanel } from "../../../../components/summary-panel";
import type { ConsumersSummaryGraphProps } from "../consumers-summary-graph";
import { ConsumersSummaryGraph } from "../consumers-summary-graph";

export interface ConsumersSummaryTabProps {
  loading: boolean;
  chartData: ConsumersSummaryGraphProps;
  summaryData: SummaryPanelProps["summaryItems"];
  onSelectMetric: (metricType: string, selected: boolean) => void;
  optimalCacProps?: OptimalCacFormProps;
}

const Container = styled.div`
  width: 100%;
  margin: auto;
  color: var(--palette-content-neutral-strong);
`;

const ChartSummaryContainer = styled.div`
  padding: 0;
`;

/**
 * ConsumersSummaryTab component
 */
export const ConsumersSummaryTab = ({
  chartData,
  loading,
  summaryData,
  onSelectMetric,
  optimalCacProps,
}: ConsumersSummaryTabProps): UIElement => {
  const intl = useIntl();
  const vsLastYear = intl.formatMessage({ id: "Consumers Summary Tab: vs last year", defaultMessage: "vs last year" });

  return (
    <Container>
      <Spacer />
      <ChartSummaryContainer>
        <SummaryPanel
          summaryItems={summaryData}
          metricReferenceText={vsLastYear}
          loading={loading}
          onSelect={onSelectMetric}
        />
        <PanelContainer>
          <PanelPadding>
            <ProfitabilityChartsContainer>
              {optimalCacProps ? <OptimalCacCalculator optimalCacData={optimalCacProps} expanded={false} /> : null}
              {chartData ? <ConsumersSummaryGraph {...chartData} loading={loading} /> : null}
            </ProfitabilityChartsContainer>
          </PanelPadding>
        </PanelContainer>
      </ChartSummaryContainer>
    </Container>
  );
};
